import _ from "lodash";
import React, { Fragment, useState, useEffect, useMemo } from "react";
import { setLocaleData, setLocaleCountry } from "actions";
import { connect, useSelector } from "react-redux";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { IntlActions, useTranslate } from "react-redux-multilingual";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { iconFontSize } from "/constants";
import LocalesValues from "components/standart/LocalesValues";
import Col3Container from "components/standart/col3Container";
import { LiveIndicator } from "components/standart";
import { ContactsButtons } from "components/standart/contactsButtons";
import { TelegramContacts } from "components/standart/TelegramContacts";
import { frontendApi, setSuccess } from "reducers/api";
import { Helmet } from "react-helmet-async";
import { useDemoPlay } from "components/common/player/refs/demo";
import FavoritesIndicator from "components/standart/indicator";

const { api } = frontendApi.actions;

const FavoritesIcon = (props) => {
  const { session } = useSelector((state) => state.user);
  const navigate = useNavigate();
  const translate = useTranslate();
  const { settings = {} } = { ...props.env };

  const location = useLocation();
  const [menuOpened, setMenuOpened] = useState(false);
  // на любом переходе закроем меню
  useEffect(() => {
    setMenuOpened(false);
  }, [location]);

  const toggleMenuHandler = () => {
    setMenuOpened(!menuOpened);
  };
  const style = { fontSize: iconFontSize, cursor: "pointer" };

  const className = "text-black text-decoration-none";
  return session.account ? (
    <div className="ml-3 mt-1 position-relative" onClick={() => navigate("/favorites")}>
      <div className="position-absolute" style={{ top: -7, right: -10 }}>
        <FavoritesIndicator />
      </div>

      <Link
        to={`/favorites`}
        className="text-black text-decoration-none -standart-header relative"
        style={{ ...style }}
      >
        <i className="far fa-heart" />
      </Link>
    </div>
  ) : null;
};

const mapStateToProps = (state) => ({
  env: state.frontend.env,
});

export default connect(mapStateToProps, {})(FavoritesIcon);
